import styled from "styled-components";
import colors from "../../../../styles/colors";

export const Container = styled.div`
  margin-bottom: 15px;
`;

export const ErrorBox = styled.div`
  background-color: ${colors.errorBgLight};
  border: 1px solid ${colors.errorBorder};
  border-left: 4px solid ${colors.errorBorderDark};
  border-radius: 6px;
  padding: 12px 16px;
  color: ${colors.errorText};
  line-height: 1.5;

  p {
    margin: 8px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }
`;

const errorListItemStyles = `
  position: relative;
  padding: 6px 0;
  color: ${colors.errorText};
  line-height: 1.5;

  &::before {
    content: "•";
    position: absolute;
    left: -16px;
    color: ${colors.errorBorderDark};
    font-weight: bold;
  }
`;

export const ErrorList = styled.ul`
  background-color: ${colors.errorBgLight};
  border: 1px solid ${colors.errorBorder};
  border-left: 4px solid ${colors.errorBorderDark};
  border-radius: 6px;
  list-style: none;
  padding: 12px 16px 12px 40px;
  margin: 0;

  li {
    ${errorListItemStyles}
  }
`;

export const InnerErrorList = styled.ul`
  list-style: none;
  padding: 0 0 0 24px;
  margin: 8px 0;

  li {
    ${errorListItemStyles}
  }
`;
